import type * as lazyFunctions from './lazyFunctions';
import { LazyAction, LazyModule } from 'owa-bundling';

const lazyModule: LazyModule<typeof lazyFunctions> = new LazyModule(
    () => import(/* webpackChunkName: "CalendarBootGroupNavActions"*/ './lazyFunctions'),
    { name: 'CalendarBootGroupNavActions' }
);

export const lazySwitchToGroupsModule: LazyAction<
    typeof lazyFunctions.lazySwitchToGroupsModule.importAndExecute,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.lazySwitchToGroupsModule.importAndExecute);
